import { sendCheckoutReceiptEmail } from "@/lib/apiClient";

function cleanEmail(value) {
  return String(value || "").trim();
}

function receiptNumberFrom(result) {
  return result?.receipt_number || result?.receiptNumber || "";
}

function committedSummary(result) {
  const summary = result?.summary || {};
  return {
    subtotal_centavos: Number(summary.subtotal_centavos || 0),
    total_discount_centavos: Number(summary.total_discount_centavos || 0),
    net_charged_centavos: Number(summary.net_charged_centavos || 0),
    total_paid_centavos: Number(summary.total_paid_centavos || 0),
    credit_applied_centavos: Number(summary.credit_applied_centavos || 0),
    refund_issued_centavos: Number(summary.refund_issued_centavos || 0),
  };
}

export async function sendCheckoutReceiptEmailNotification({
  result,
  hydration,
  sendReceiptEmail = sendCheckoutReceiptEmail,
  toast,
} = {}) {
  const receiptNumber = receiptNumberFrom(result);
  if (!receiptNumber) {
    toast?.warning?.("Receipt was not sent: no receipt was issued.");
    return { ok: false, code: "missing_receipt_number" };
  }

  const patient = hydration?.patient || {};
  const toEmail = cleanEmail(patient.email);
  if (!toEmail) {
    toast?.warning?.("Receipt was not sent: patient has no email on file.");
    return { ok: false, code: "missing_patient_email" };
  }

  const clinic = hydration?.clinic || {};
  const payload = {
    to_email: toEmail,
    patient_name: patient.full_name || [patient.first_name, patient.last_name].filter(Boolean).join(" ").trim() || "Patient",
    clinic_name: clinic.name || hydration?.clinic_name || "Dental Clinic",
    clinic_slug: clinic.slug || hydration?.clinic_slug || "clinic",
    receipt_number: receiptNumber,
    issued_at: result?.completed_at || result?.finalized_at || result?.created_at || new Date().toISOString(),
    currency: hydration?.currency || "PHP",
    summary: committedSummary(result),
  };

  let response;
  try {
    response = await sendReceiptEmail(payload);
  } catch (err) {
    response = {
      ok: false,
      code: "send_exception",
      message: err?.message || "Email backend failed.",
    };
  }

  if (response?.ok) {
    toast?.success?.("Receipt successfully sent.");
  } else {
    toast?.error?.(`Receipt was not sent: ${response?.message || "Email failed."}`);
  }
  return response;
}
